import type {RouteRecordRaw} from "vue-router";

export const routeName = 'MainValidateById';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'check/:docId(\\d+)/:fileId(\\d+)',
    props: true,
    component: () => import('@/pages/ValidateDoc'),
};
